import { Trans, useTranslation } from '@ecomm/i18n'
import type { ReactNode } from 'react'
import { PerDaySlash } from '../A11yHelpers/PerDaySlash'
import { AddPlanToCartButtonProduct } from '../AddPlanToCartButton'

export function ModalFooter({
  price,
  disclaimer,
  showCTA = false
}: {
  readonly price: string
  readonly disclaimer?: string | ReactNode
  readonly showCTA?: boolean
}) {
  const { t } = useTranslation('maps')

  return (
    <footer className="flex gap-2 justify-between" data-testid="ModalFooter">
      <div>
        <div className="m-0 font-bold">
          <Trans components={{ per: <PerDaySlash /> }}>{price}</Trans>
        </div>
        <p className="m-0">{t('microtext.no-contract')}</p>
      </div>
      <div>
        {showCTA && (
          <AddPlanToCartButtonProduct
            buttonText="Add free month"
            className="mt-2 block !text-sm md:!text-lg"
            quantity={1}
            sku={'SSSAPP-SMB__18993924'}
          />
        )}
        {disclaimer && <p className="text-xs m-0">{disclaimer}</p>}
      </div>
    </footer>
  )
}
